export default "__VITE_ASSET__d8eBOsBzDDx4DxnC9kxu_w__"